function Services() {
  return (
    <>
      <section className="services" id="services">
        <div className="max-width">
          <h2 className="title">My services</h2>

          <div className="serv-content">
            <div className="card">
              <div className="box">
                <i className="fas fa-book-open"></i>
                <div className="text">Financial Planning</div>
                <p>Investment Advise</p>
                <p>Star Health Mediclaim</p>
                <p>Life Insurance Corporation</p>
              </div>
            </div>

            <div className="card">
              <div className="box">
                <i className="fas fa-book-open"></i>
                <div className="text">Book-Keeping</div>
                <p>Client dealing</p>
                <p>Stock Maintenance</p>
                <p>MSME Registration</p>
                <p>Labour Certificate</p>
                <p>Verification of bills</p>
                <p>Maintaining Book Reconciliation</p>
              </div>
            </div>

            <div className="card">
              <div className="box">
                <i className="fas fa-file-signature"></i>
                <div className="text">ITR &amp; GST Filing</div>
                <p>TDS returns and advise</p>
                <p>GST Compliances</p>
                <p>Yearly budgeting</p>
                <p>Individuals, E-Commerce data Analyzing and Auditing</p>
                <p>
                  Finance–Collating &amp; Profitability, Analyzing P&amp;L,
                  Balance Sheet
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
